const testimonials = (state = {}, action) => {
    switch (action.type) {
        case 'TESTIMONIALS_DATA_LOADED' : 
            return{
            ...state,
            testimonialsData : action.payload
            }
        default:
            return state
        }
  }
  export default testimonials